/*********************************************************************************************
 * Change the quantity value in the input field and update the related prices.
 *
 * @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
 * @param {string} inputId - The ID of the input field where the quantity is adjusted.
 */
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = ((priceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
 * Read-more x Read-less
 *
 */
document.addEventListener("DOMContentLoaded", function () {
	const wrapper = document.querySelector(".mm-pfc-description");
	if (!wrapper) return;

    const description = wrapper.querySelector(".mm-description");
	const toggle = wrapper.querySelector(".mm-read-more");

    if (!description) return;

	const seeMoreText = wrapper.dataset.seeMore || "Lire plus";
	const seeLessText = wrapper.dataset.seeLess || "Lire moins";

    const shortEl = description.querySelector(".mm-desc-short");
    const fullEl = description.querySelector(".mm-desc-full");

    // S'il n'y a pas de bouton (description <= 200), rien à faire
    if (!toggle || !shortEl || !fullEl) return;

    toggle.addEventListener("click", () => {
        const showingFull = fullEl.style.display !== "none";
        if (showingFull) {
            fullEl.style.display = "none";
            shortEl.style.display = "flex";
            toggle.textContent = seeMoreText;
        } else {
            shortEl.style.display = "none";
            fullEl.style.display = "flex";
            toggle.textContent = seeLessText;
        }
    });

	// Accessibilité (Enter ou Espace)
	toggle.addEventListener("keydown", (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			toggle.click();
		}
	});
});

/*********************************************************************************************
 * Initialize the Splide Reassurance.
 *
 */
function mmInitSplideReaProduct() {
	const id = ".mm-splide-rea";
	const splideElem = document.querySelector(id);
	if (splideElem) {
		if (splideElem.splideInstance) {
			splideElem.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElem, {
			type: "loop",
			autoplay: true,
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
		}).mount();
		splideElem.splideInstance = splideInstance;
	}
}

/*********************************************************************************************
 * Class for handling variant selection
 *
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 *
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 *
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 *
	 */
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 *
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 *
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
		// Mise à jour directe de la valeur de l'input avec l'ID du variant
		const variantInput = this.container.querySelector("#product_form_selected_variant_id");
		if (variantInput && this.currentVariant) {
			variantInput.value = this.currentVariant.id;
		}

		this.updateElementOuter(".mm-product-price", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-cta", html);
		this.updateElementOuter(".mm-contenance-product", html);

		this.updateImagesVariant();
	}

	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of multiple elements.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateMultipleElement(selector, html) {
		const destination = this.container.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			for (let index = 0; index < source.length; index++) {
				destination[index].outerHTML = source[index].outerHTML;
			}
		}
	}

	/*********************************************************************************************
	 * Update the media carousel to display the featured media of the current variant.
	 *
	 */
	updateMedia() {
		if (this.currentVariant && this.currentVariant.featured_media) {
			var variant_media_id = this.currentVariant.featured_media.id;
			var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

			allMainMedia.forEach((media, index) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					main.go(index);
				}
			});
		}
	}

	/*********************************************************************************************
	 * Update the visibility of the media sliders for the current variant.
	 *
	 */
	updateImagesVariant() {
		var allMainMedia = document.querySelectorAll(".main-slider-variant");
		allMainMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
		var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
		allThumbnailMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
	}
}

/*********************************************************************************************
 * Define the custom element
 *
 */
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
 * Splide Media - Initialisation
 *
 */
function initializeSplideWithThumbnails(sectionElem) {
	const mainElem = sectionElem.querySelector("#main-slider");
	const thumbnailElem = sectionElem.querySelector("#thumbnail-slider");

	if (!thumbnailElem || !mainElem) return;

	// SLIDER PRODUCT
	const main = new Splide(mainElem, {
		type: "fade",
		rewind: true,
		heightRatio: 1,
		pagination: false,
		breakpoints: {
			768: {
				pagination: true,
			},
		},
	});

	const thumbnails = new Splide(thumbnailElem, {
		type: "slide",
		perPage: 6,
		gap: 8,
		height: "100%",
		width: 90,
		direction: "ttb",
		isNavigation: true,
		pagination: false,
		arrows: false,
		breakpoints: {
			768: {
				arrows: false,
				direction: "ltr",
				width: false,
				heightRatio: 1,
				isNavigation: false,
				perPage: 1,
				destroy: true,
			},
		},
	});

	window.main = main;
	main.sync(thumbnails); // 🔄 Synchronisation

	thumbnails.mount();
	main.mount();
}

function initializeSplidesWithThumbnails(attribute = "data-section-id") {
	const sections = document.querySelectorAll(`[${attribute}]`);
	sections.forEach(initializeSplideWithThumbnails);
}

/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	initializeSplidesWithThumbnails();
	mmInitSplideReaProduct();
});
